import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Plani8EndPoints, Plani8EnvironmentService } from './plani8-environment.service';
import { factoriesListMock } from './mocks/factory-list-api-mock';
import {
  TRESPONSE_FACTORY_LIST,
  TREQUEST_ALLOCATE_PRODUCTS_TYPES_TO_FACTORIES,
  TREQUEST_UPDATE_FACTORY_UOM,
  TRESPONSE_GET_FACTORY_UOM,
  TRESPONSE_UPDATE_FACTORY_UOM,
  TREQUEST_LEARNING_CURVE_DETAILS,
  TRESPONSE_LEARNING_CURVE_DETAILS,
  TREQUEST_ADD_LEARNING_CURVE_DAY,
  TREQUEST_ADD_UPDATE_LEARNING_CURVE,
  TREQUEST_DELETE_LEARNING_CURVES,
  TRESPONSE_LEARNING_CURVE_SUCCESS,
  TREQUEST_RESET_COUNT,
  TREQUEST_ADD_EDIT_OPERATOR_COUNT,
  TREQUEST_FACTORY_SHIFT,
  TRESPONSE_FACTORY_SHIFT,
  TREQUEST_PLANI8_EMPLOYEE_LIST,
  TREQUEST_UPDATE_PLANI8_EMPLOYEE_LIST,
  TREQUEST_UPDATE_TEAM,
  TREQUEST_DELETE_TEAM,
  TRESPONSE_PLANI8_EMPLOYEE_LIST,
  TRESPONSE_TEAM_LIST,
  TRESPONSE_UPDATE_TEAM,
  TRESPONSE_DELETE_TEAM,
  TRESPONSE_UPDATE_PLANI8_EMPLOYEE_LIST,
  TREQUEST_ADD_EDIT_WORKING_HOURS,
  TRESPONSE_COUNT_UPDATE_SUCCESS,
  TRESPONSE_FACTORY_HOLIDAYS,
  TREQUEST_ADD_EDIT_FACTORY_HOLIDAYS,
  TREQUEST_DELETE_FACTORY_HOLIDAYS,
  TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY,
  TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY,
  TREQUEST_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TREQUEST_DELETE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TREQUEST_TNA_TEMPLATE_LISTING,
  TRESPONSE_TNA_TEMPLATE_LISTING,
  TREQUEST_UPDATE_TNA_TEMPLATE_NAME,
  TREQUEST_DELETE_TNA_TEMPLATE,
  TREPONSE_TNA_TEMPLATE_UPDATE_SUCCESS,
  TRESPONSE_TNA_DEFAULT_STEPS,
  TREQUEST_CREATE_TNA_TEMPLATE,
  TRESPONSE_TNA_TEMPLATE_DETAILS,
  TREQUEST_ADD_EDIT_TNA_TEMPLATE_STEP,
  TREQUEST_DELETE_TNA_TEMPLATE_STEP,
  TREQUEST_ORDER_ATTRIBUTES,
  TRESPONSE_ORDER_ATTRIBUTES,
  TREQUEST_ADD_UPDATE_ORDER_ATTRIBUTES,
  TREQUEST_DELETE_ORDER_ATTRIBUTES,
  TRESPONSE_ORDER_ATTRIBUTES_TYPES,
  TREQUEST_ORDER_LIST,
  TRESPONSE_ORDER_LIST,
  TRESPONSE_ORDER_UPLOAD_DETAILS,
  TRESPONSE_GET_TNA_ORDER_TEMPLATE,
  TREQUEST_ASSIGN_TNA_TO_ORDERS,
  TREQUEST_TNA_BOARD_LISTING,
  TRESPONSE_TNA_BOARD_LISTING,
  TRESPONSE_TNA_BOARD_ORDER_DETAILS,
  TREQUEST_ORDER_SINGLE_FACTORY_ALLOCATION,
  TREQUEST_ORDER_VIEW_FACTORY_ALLOCATION,
  TREQUEST_ORDER_ALLOCATION_CREATE_SPLIT_VIEW,
  TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS,
  TREQUEST_ALLOCATE_ORDER_MULTIPLE_FACTORIES,
  TREQUEST_GET_TNA_ORDER_STEP_LIST,
  TRESPONSE_GET_TNA_ORDER_STEP_LIST,
  TRESPONSE_GET_TNA_ORDER_STEP,
  TREQUEST_UPDATE_TNA_STEP,
  TREQUEST_BULK_COMPLETE_TNA_ORDER_STEPS,
  TRESPONSE_BULK_COMPLETE_TNA_ORDER_STEPS,
  TRESPONSE_LL_SHIFT,
  TREQUEST_ADD_EDIT_LINE_WORKING_HOURS,
  TREQUEST_RESET_LINE_SHIFT_COUNT,
  TREQUEST_ORDER_DETAILS_PLANNING_CARD,
  TRESPONSE_ORDER_DETAILS_PLANNING_CARD,
  TREQUEST_EDIT_ORDER_DETAILS_HEADER,
  TREQUEST_DELETE_ORDERS,
  TREQUEST_ORDER_DETAILS_LEARNING_CURVE,
  TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES,
  TREQUEST_EDIT_LEARNING_CURVE_ORDER_EFFICIENCY,
  TREQUEST_ORDER_DETAILS_HEADER,
  TRESPONSE_ORDER_DETAILS_HEADER,
  TRESPONSE_ORDER_DETAILS_LEARNING_CURVE,
  TRESPONSE_ORDER_DETAILS_VIEW_LEARNING_CURVE,
  TRESPONSE_PO_DETAILS_CARD,
  TRESPONSE_PO_DETAILS_COLOR_SIZE,
  TRESPONSE_ORDER_ALLOCATION_CARD_DATA,
  TRESPONSE_TNA_BOARD_ORDER_PROGRESS,
  TREQUEST_VIEW_STRIP_LEVEL_EFFICIENCY,
  TRESPONSE_VIEW_STRIP_LEVEL_EFFICIENCY,
  TREQUEST_VIEW_OTL_EFFICIENCY,
  TRESPONSE_VIEW_OTL_EFFICIENCY,
  TREQUEST_EDIT_STRIP_LEVEL_EFFICIENCY,
  TREQUEST_EDIT_OTL_EFFICIENCY,
  TRESPONSE_PLANNED_ORDER_PROGRESS,
  TREQUEST_PLANNED_ORDER_PROGRESS,
  TREQUEST_LL_LOAD_ORDER,
  TREQUEST_LlBoardListing,
  TRESPONSE_LLBoardListing,
  TRESPONSE_GENERAL_HTTP,
  TREQUEST_TNA_BOARD_FILTERS,
  TRESPONSE_TNA_BOARD_FILTERS,
  TRESPONSE_TNA_BOARD_FILTERS_SEARCH_RES,
  TRESPONSE_OPLDetailsDTO,
  TREQUEST_LL_SPLIT_STRIP_ACTION,
  TRESPONSE_LL_POLL_STATUS,
  TRESPONSE_LL_TASK_MANAGER,
  TLL_RECALIBRATE_TYPES,
  TRESPONSE_LL_LEARNING_CURVE_DETAILS,
  TREQUEST_ADD_UPDATE_LL_LEARNING_CURVE,
  TRESPONSE_LL_LEARNING_CURVE_BY_FACTORY_OTL,
  TREQUEST_ADD_UPDATE_LL_LC_BY_FACTORY_OTL,
  TREQUEST_LINE_LEVEL_STRIP_LIST,
  TRESPONSE_LINE_LEVEL_STRIP_LIST,
  TREQUEST_SHIFT_STRIPS,
  TREQUEST_UNLOAD_MULTIPLE_STRIPS_REMOVE_ORDERS,
  TREQUEST_UNLOAD_STRIP_MOVE_PARTIALLY,
  TREQUEST_ADD_EDIT_NOTE,
  TRESPONSE_LINE_STRIP_PLANNED_NUMBERS,
  TRESPONSE_TNA_ORDER_TEMPLATE,
  TREQUEST_UPDATE_DEFAULT_WORKFORCE_COUNT,
  TREQUEST_ADD_EDIT_WORKFORCE_COUNT,
  TREQUEST_ADD_EDIT_LINE_WORKFORCE_COUNT,
  TREQUEST_WORKFORCE_RESET_TO_DEFAULT,
  TREQUEST_RESET_LINE_WORKFORCE_COUNT,
  TRESPONSE_DAILY_OPL_CAPACITIES,
  TREQUEST_OPL_CAPACITIES_INFO,
  TRESPONSE_WEEKLY_OPL_CAPACITIES,
  TRESPONSE_OTL_CAPACITIES_INFO,
  TREQUEST_OTL_CAPACITIES_INFO,
  TRESPONSE_HL_BOARD_LISTING,
  TREQUEST_HL_BOARD_LISTING,
  TREQUEST_HL_BOARD_SECTION_WISE_LISTING,
  TRESPONSE_HL_BOARD_SECTION_WISE_LISTING,
  TRESPONSE_EFFICIENCY_CONFIG,
  TRESPONSE_BENCHMARKING_CONFIG,
  TREQUEST_UPDATE_BENCHMARKING_CONFIG,
  TREQUEST_UPDATE_EFFICIENCY_CONFIG,
  TRESPONSE_HL_POLL_STATUS,
  TREQUEST_DAILY_OPL_CAPACITIES_FILTERS,
  TRESPONSE_OTL_OPL_CONFIG,
  TREQUEST_UPDATE_OTL_OPL_CONFIG,
  TRESPONSE_SED_CONFIG,
  TREQUEST_UPDATE_SED_CONFIG,
  TREQUEST_AUTO_UPDATE_TARGET_DATES,
  TREQUEST_UPDATE_EXPECTED_DATE_CONFIG,
  TRESPONSE_EXPECTED_DATE_CONFIG,
  TRESPONSE_UPDATE_EXPECTED_DATE_CONFIG,
  TREQUEST_RESET_STRIP_LEVEL_EFFICIENCY,
  TREQUEST_RESET_OTL_EFFICIENCY,
  TOrderListingBucketInfo,
  TREQUEST_LL_LOAD_ORDER_THRESHOLD,
  TREQUEST_GET_TNA_STEP_APPROVAL_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS,
  TREQUEST_GET_TNA_STEP_APPROVAL_PENDING_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS,
  TREQUEST_CREATE_TNA_STEP_APPROVAL_REQUEST,
  TREQUEST_UPDATE_TNA_STEP_APPROVAL,
  TRESPONSE_GET_TNA_STEP_APPROVAL_EMPLOYEES,
  TApprovalType,
  TRESPONSE_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TRESPONSE_MATERIAL_IN_HOUSE,
  TRESPONSE_START_ORDER_DETAILS_SYNC,
  TRESPONSE_ORDER_DETAILS_POLL_STATUS,
  TMaterialInHouseByOtlResponse,
  TREQUEST_ADD_EDIT_SHIFT,
  TOrgHeirachy,
  TRESPONSE_GET_ALL_SHIFTS,
  TRESPONSE_GET_SHIFT_BY_ID,
  TREQUEST_DEFAULT_COUNT_EDIT_ORDER_DETAILS,
  TRESPONSE_OPL_LIST,
  TREQUEST_RESET_LL_LC_BY_FACTORY_OTL,
  TREQUEST_LL_LINK_STRIP,
  TREQUEST_LL_CONTINUE_LINK_STRIP,
  TRESPONSE_STRIPS_OVERLAPPING,
  TREQUEST_LL_GET_QTY_BY_DATE,
  TREQUEST_LL_GET_QTY_BY_DELAY,
  TRESPONSE_LL_GET_QTY_BY_DELAY,
  TRESPONSE_LL_GET_QTY_BY_DATE,
  TREQUEST_LL_MERGE_STRIPS,
  TREQUEST_FACTORY_ALLOCATION_LISTING,
  TRESPONSE_FACTORY_ALLOCATION_FILTERS,
  TREQUEST_FACTORY_ALLOCATION_PARTIAL,
  TRESPONSE_FACTORY_ALLOCATION_LISTING,
  TREQUEST_LL_ADD_LEARNING_CURVE_DAY,
  TREQUEST_UPDATE_DEFAULT_WORKING_HOURS_REQUEST,
  TRESPONSE_TNA_TARGET_UPDATES_CONFIG,
  TREQUEST_TNA_TARGET_UPDATES_CONFIG_UPDATE,
  TREQUEST_LL_PULL_FORWARD,
  TREQUEST_ORDER_DETAILS_DELETE_ALLOCATION,
  TREQUEST_UPDATE_STEP_BY_TEMPLATE_ID,
  TREQUEST_ARCHIVE_USER,
  TRESPONSE_ARCHIVE_USER,
  TREQUEST_GET_PENDING_TNA_STEPS,
  TRESPONSE_GET_PENDING_TNA_STEPS,
  TRESPONSE_LL_LOAD_ORDER_THRESHOLD,
  TREQUEST_ORDER_CHECKLIST_LISTING,
  TRESPONSE_ORDER_CHECKLIST_LISTING,
  TREQUEST_SUBMIT_ORDER_CHECKLIST,
  TREQUEST_BULK_COMPLETE_CHECKLIST,
  TOrderChecklistItem,
  TREQUEST_CREATE_PROCESS,
  TRESPONSE_PROCESS_LISTING,
  TREQUEST_ADD_EDIT_PROCESS_MAP,
  TRESPONSE_GET_PROCESS_MAP_BY_ID,
  TRESPONSE_PROCESS_MAP_LISTING,
  TREQUEST_ADD_EDIT_PROCESS_MAP_TO_OTL,
  TRESPONSE_GET_PROCESS_MAP_BY_OTL_ID,
  TREQUEST_GET_CAPACITY_BOARD,
  TRESPONSE_GET_CAPACITY_BOARD,
  TRESPONSE_GET_CAPACITY_BOARD_STATUS,
  TRESPONSE_ORDER_TIMELINE_CARD_DATA,
  TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA,
  TRESPONSE_GET_CAPACITY_STRIP_DETAILS,
  TREQUEST_GET_CAPACITY_STRIP_DETAILS,
  TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA,
  TREQUEST_LL_SEARCH_STRIPS,
  TRESPONSE_LL_SEARCH_STRIPS,
  TREQUEST_CLOSE_OPL,
  TREQUEST_CLOSE_OPL_BY_OPL_ID,
  TREQUEST_GET_OPTIMAL_PLAN_BY_OPL_ID,
  TRESPONSE_GET_OPTIMAL_PLAN_BY_OPL_ID,
  TREQUEST_LOAD_OPL_STRIPS,
  TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING,
  TREQUEST_ADD_EDIT_PROCESS_FACTORY_ASSIGN,
  TREQUEST_GET_PLANNING_BOARD,
  TRESPONSE_GET_PLANNING_BOARD,
  TREQUEST_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID,
  TRESPONSE_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID,
  TRESPONSE_GET_ACCOUNT_SHIFT_NAMES,
  TRESPONSE_GET_ORDER_TIMELINE_VIEW,
  TREQUEST_GET_ORDER_TIMELINE_VIEW,
  TREQUEST_ORDER_DETAILS_DELETE_ALLOCATION_BY_FACTORY,
} from '@monorepo/types';

import { TLiftedFormModel } from '@monorepo/ui';

@Injectable({
  providedIn: 'root',
})
export class Plani8DataService {
  llFetchCounter = 0;
  constructor(private http: HttpClient, private plani8EnvironmentService: Plani8EnvironmentService) {}

  // FACTORY LIST

  fetchFactoryListData() {
    console.log('fetchFactoryListData', factoriesListMock);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_LIST');
    return this.http.get<TRESPONSE_FACTORY_LIST>(url);
  }

  allocateProductTypesToFactories(payload: TREQUEST_ALLOCATE_PRODUCTS_TYPES_TO_FACTORIES) {
    console.log('allocateProductTypesToFactories,', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('ALLOCATE_PRODUCTS_TYPES');
    return this.http.post(url, { ...payload, source_type: 'planning-app' });
    // return of({
    //   status: 'SUCCESS',
    //   message: '',
    // });
  }

  fetchFactoryUom(factoryId: string) {
    console.log('fetchUom', factoryId);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_UOM').replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_GET_FACTORY_UOM>(url);
    //return of(uomApiMock);
  }

  updateFactoryUom(factoryId: string, payload: TREQUEST_UPDATE_FACTORY_UOM) {
    console.log('postUomUpdate', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_FACTORY_UOM').replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_UPDATE_FACTORY_UOM>(url, { ...payload, source_type: 'planning-app' });
    //return of(uomUpdateApiMock);
  }

  //FACTORY CONFIG SETUP

  fetchFactoryEfficiencyConfigList() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_EFFICIENCY_CONFIG_LIST');
    return this.http.get<TRESPONSE_EFFICIENCY_CONFIG>(url);
  }

  updateFactoryEfficiencyConfig(payload: TREQUEST_UPDATE_EFFICIENCY_CONFIG) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_EFFICIENCY_CONFIG');
    return this.http.post(url, payload);
  }

  fetchFactoryBenchmarkingConfigList() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_BENCHMARKING_CONFIG_LIST');
    return this.http.get<TRESPONSE_BENCHMARKING_CONFIG>(url);
  }

  updateFactoryBenchmarkingConfig(payload: TREQUEST_UPDATE_BENCHMARKING_CONFIG) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_BENCHMARKING_CONFIG');
    return this.http.post(url, payload);
  }

  fetchFactoryOtlOplConfigList() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_OTL_OPL_CONFIG_LIST');
    return this.http.get<TRESPONSE_OTL_OPL_CONFIG>(url);
  }

  updateFactoryOtlOplConfig(payload: TREQUEST_UPDATE_OTL_OPL_CONFIG) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_OTL_OPL_CONFIG');
    return this.http.post(url, payload);
  }

  fetchFactorySEDConfig() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_SED_CONFIG');
    return this.http.get<TRESPONSE_SED_CONFIG>(url);
  }

  updateFactorySEDConfig(payload: TREQUEST_UPDATE_SED_CONFIG) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_SED_CONFIG');
    return this.http.post(url, payload);
  }

  fetchFactoryExpectedDateConfig() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_DATES_FROM_PLAN_CONFIG');
    return this.http.get<TRESPONSE_EXPECTED_DATE_CONFIG>(url);
  }

  fetchTnaTargetUpdatesConfig() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_TARGET_UPDATES_CONFIG');
    return this.http.get<TRESPONSE_TNA_TARGET_UPDATES_CONFIG>(url);
  }

  updateTnaTargetConfig(payload: TREQUEST_TNA_TARGET_UPDATES_CONFIG_UPDATE) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_TNA_TARGET_UPDATES_CONFIG');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, payload);
  }

  updateFactoryExpectedDateConfig(payload: TREQUEST_UPDATE_EXPECTED_DATE_CONFIG) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_DATES_FROM_PLAN_CONFIG');
    return this.http.post<TRESPONSE_UPDATE_EXPECTED_DATE_CONFIG>(url, payload);
  }

  //ORDER ATTRIBUTES

  fetchOrderAttributesData(payload: TREQUEST_ORDER_ATTRIBUTES) {
    console.log('fetchOrderAttributesData', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_ATTRIBUTES');
    return this.http.post<TRESPONSE_ORDER_ATTRIBUTES>(url, payload);
    //return of(orderAttributesData);
  }

  getOrderAttributesTypes() {
    console.log('getOrderAttributesTypes');
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_ATTRIBUTES_TYPES');
    return this.http.get<TRESPONSE_ORDER_ATTRIBUTES_TYPES>(url);
    //return of(orderAttributesData);
  }

  addUpdateOrderAttributes(payload: TREQUEST_ADD_UPDATE_ORDER_ATTRIBUTES) {
    console.log('addUpdateOrderAttributes,', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_UPDATE_ORDER_ATTRIBUTES');
    return this.http.post(url, payload);
    // return of({
    //   status: 'SUCCESS',
    //   message: '',
    // });
  }

  deleteOrderAttributes(payload: TREQUEST_DELETE_ORDER_ATTRIBUTES) {
    console.log('deleteOrderAttributes', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_ORDER_ATTRIBUTES');
    return this.http.post(url, payload);
    // return of({
    //   status: 'SUCCESS',
    //   message: '',
    // });
  }

  //LEARNING CURVES

  fetchLearningCurves(payload: TREQUEST_LEARNING_CURVE_DETAILS) {
    console.log('fetchLearningCurves', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_LEARNING_CURVES');
    return this.http.post<TRESPONSE_LEARNING_CURVE_DETAILS>(url, { ...payload, source_type: 'planning-app' });
    //return of(learningCurveMock);
  }

  addUpdateLearningCurves(payload: TREQUEST_ADD_UPDATE_LEARNING_CURVE) {
    console.log('addUpdateLearningCurves');
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_UPDATE_LEARNING_CURVE');
    return this.http.post<TRESPONSE_LEARNING_CURVE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
    //return of(uomUpdateApiMock);
  }

  addLearningCurveDay(payload: TREQUEST_ADD_LEARNING_CURVE_DAY) {
    console.log('addLearningCurveDay', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_LEARNING_CURVE_DAY');
    return this.http.post<TRESPONSE_LEARNING_CURVE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
    //return of(uomUpdateApiMock);
  }

  deleteLearningCurves(payload: TREQUEST_DELETE_LEARNING_CURVES) {
    console.log('deleteLearningCurves', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_LEARNING_CURVES');
    return this.http.post<TRESPONSE_GET_FACTORY_UOM>(url, { ...payload, source_type: 'planning-app' });
    //return of(uomUpdateApiMock);
  }

  // FACTORY SHIFT SETUP

  fetchFactoryShifts(factoryId: string, payload: TREQUEST_FACTORY_SHIFT) {
    console.log('fetchFactoryShifts', factoryId, payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_SHIFTS').replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_FACTORY_SHIFT>(url, { ...payload, source_type: 'planning-app' });
    // return of(shiftSetupMock['res']);
  }

  addEditFactoryOperatorCount(factoryId: string, payload: TREQUEST_ADD_EDIT_OPERATOR_COUNT) {
    console.log('addEditFactoryOperatorCount', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('ADD_EDIT_FACTORY_OPERATOR_COUNT')
      .replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_COUNT_UPDATE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
  }

  resetFactoryOperatorCount(factoryId: string, payload: TREQUEST_RESET_COUNT) {
    console.log('resetFactoryOperatorCount', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('RESET_FACTORY_OPERATOR_COUNT')
      .replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_COUNT_UPDATE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
  }

  addEditFactoryWorkingHours(factoryId: string, payload: TREQUEST_ADD_EDIT_WORKING_HOURS) {
    console.log('addEditFactoryWorkingHours', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('ADD_EDIT_FACTORY_WORKING_HOURS')
      .replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_COUNT_UPDATE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
  }

  resetFactoryWorkingHours(factoryId: string, payload: TREQUEST_RESET_COUNT) {
    console.log('resetFactoryWorkingHours', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('RESET_FACTORY_WORKING_HOURS')
      .replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_COUNT_UPDATE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
  }

  updateDefaultWorkforceCountRequest(payload: TREQUEST_UPDATE_DEFAULT_WORKFORCE_COUNT) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_DEFAULT_WORKFORCE_COUNT');
    return this.http.post(url, payload);
  }

  updateDefaultWorkingHours(payload: TREQUEST_UPDATE_DEFAULT_WORKING_HOURS_REQUEST, factoryId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('UPDATE_DEFAULT_WORKING_HOURS')
      .replace(':factoryId', factoryId);
    return this.http.post(url, payload);
  }

  addEditWorkForceCount(payload: TREQUEST_ADD_EDIT_WORKFORCE_COUNT, factoryId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('ADD_EDIT_WORKFORCE_COUNT')
      .replace(':factoryId', factoryId);
    return this.http.post(url, payload);
  }

  workForceResetToDefault(payload: TREQUEST_WORKFORCE_RESET_TO_DEFAULT, factoryId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('WORKFORCE_RESET_TO_DEFAULT')
      .replace(':factoryId', factoryId);
    return this.http.post(url, payload);
  }

  getOrgHierarchy(factoryId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORG_HIERARCHY').replace(':factoryId', factoryId);
    return this.http.get<TOrgHeirachy>(url);
  }

  getAllShifts() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ALL_SHIFTS');
    return this.http.get<TRESPONSE_GET_ACCOUNT_SHIFT_NAMES>(url);
  }

  getAllShiftsByFactory(factoryId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('GET_ALL_SHIFTS_BY_FACTORY')
      .replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_GET_ALL_SHIFTS>(url);
  }

  addEditShift(payload: TREQUEST_ADD_EDIT_SHIFT) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_SHIFT');
    return this.http.post(url, payload);
  }

  getShiftById(shiftId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_SHIFT_BY_ID').replace(':shiftId', shiftId);
    return this.http.get<TRESPONSE_GET_SHIFT_BY_ID>(url);
  }

  //LL Shift Setup
  addEditLineWorkForceCount(payload: TREQUEST_ADD_EDIT_LINE_WORKFORCE_COUNT, factoryId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('ADD_EDIT_LINE_WORKFORCE_COUNT')
      .replace(':factoryId', factoryId);
    return this.http.post(url, payload);
  }

  resetLineWorkForceCount(payload: TREQUEST_RESET_LINE_WORKFORCE_COUNT, factoryId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('RESET_LINE_WORKFORCE_COUNT')
      .replace(':factoryId', factoryId);
    return this.http.post(url, payload);
  }

  //Employee

  fetchEmployeeListData(payload: TREQUEST_PLANI8_EMPLOYEE_LIST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_EMPLOYEE_LIST');
    return this.http.post<TRESPONSE_PLANI8_EMPLOYEE_LIST>(url, payload);
  }

  getPendingTNASteps(payload: TREQUEST_GET_PENDING_TNA_STEPS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PENDING_TNA_STEPS');
    return this.http.post<TRESPONSE_GET_PENDING_TNA_STEPS>(url, payload);
  }

  archiveUser(payload: TREQUEST_ARCHIVE_USER) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ARCHIVE_USER_EMPLOYEE_LIST');
    return this.http.post<TRESPONSE_ARCHIVE_USER>(url, payload);
  }

  updateEmployeeData(payload: TREQUEST_UPDATE_PLANI8_EMPLOYEE_LIST) {
    console.log('updateEmployeeData', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('CREATE_UPDATE_EMPLOYEE');
    return this.http.post<TRESPONSE_UPDATE_PLANI8_EMPLOYEE_LIST>(url, payload);
  }

  fetchTeamList() {
    console.log('fetchTeamList');
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TEAM_LIST');
    return this.http.get<TRESPONSE_TEAM_LIST>(url);
    // return of(viewTeamList);
  }

  updateTeams(payload: TREQUEST_UPDATE_TEAM) {
    console.log('updateTeams', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('CREATE_UPDATE_TEAM');
    return this.http.post<TRESPONSE_UPDATE_TEAM>(url, payload);
  }

  deleteTeams(payload: TREQUEST_DELETE_TEAM) {
    console.log('deleteTeams', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_TEAM');
    return this.http.post<TRESPONSE_DELETE_TEAM>(url, payload);
  }

  //HOLIDAYS

  fetchFactoryHolidays(factoryId: string) {
    console.log('fetchFactoryHolidays');
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_HOLIDAYS').replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_FACTORY_HOLIDAYS>(url);
    //return of(productTypesMock);
  }

  addEditFactoryHolidays(factoryId: string, payload: TREQUEST_ADD_EDIT_FACTORY_HOLIDAYS) {
    console.log('addEditFactoryHolidays', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('ADD_EDIT_FACTORY_HOLIDAYS')
      .replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_COUNT_UPDATE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
  }

  deleteFactoryHolidays(factoryId: string, payload: TREQUEST_DELETE_FACTORY_HOLIDAYS) {
    console.log('deleteFactoryHolidays', factoryId, payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_FACTORY_HOLIDAYS').replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_COUNT_UPDATE_SUCCESS>(url, { ...payload, source_type: 'planning-app' });
  }

  fetchFactoryProductLineEfficiency(factoryId: string, payload: TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY) {
    console.log('fetchFactoryProductLineEfficiency', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('GET_PRODUCT_LINE_EFFICIENCY_LIST')
      .replace(':factoryId', factoryId);
    // return of(lineWiseEfficiencyListing);
    return this.http.post<TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY>(url, payload);
  }

  updateFactoryProductLineEfficiency(factoryId: string, payload: TREQUEST_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES) {
    console.log('updateFactoryProductLineEfficiency', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('ADD_EDIT_PRODUCT_LINE_EFFICIENCIES')
      .replace(':factoryId', factoryId);
    // return of(lineWiseEfficiencyListing);
    return this.http.post<TRESPONSE_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES>(url, payload);
  }

  deleteFactoryProductLineEfficiency(factoryId: string, payload: TREQUEST_DELETE_FACTORY_PRODUCT_LINE_EFFICIENCIES) {
    console.log('updateFactoryProductLineEfficiency', factoryId, payload);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('DELETE_PRODUCT_LINE_EFFICIENCY')
      .replace(':factoryId', factoryId);
    // return of(lineWiseEfficiencyListing);
    return this.http.post(url, payload);
  }

  //Tna Template listing

  fetchTnaTemplateList(payload: TREQUEST_TNA_TEMPLATE_LISTING) {
    console.log('fetchTnaTemplateList', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_TEMPLATE_LIST');
    return this.http.post<TRESPONSE_TNA_TEMPLATE_LISTING>(url, payload);
    //return of(tnaTemplateListingResponse);
  }

  updateTnaTemplateName(payload: TREQUEST_UPDATE_TNA_TEMPLATE_NAME) {
    console.log('updateTnaTemplateName', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_TNA_TEMPLATE_NAME');
    return this.http.post<TREPONSE_TNA_TEMPLATE_UPDATE_SUCCESS>(url, payload);
    //return of({ status: 'SUCCESS' });
  }

  deleteTnaTemplate(payload: TREQUEST_DELETE_TNA_TEMPLATE) {
    console.log('deleteTnaTemplate', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_TNA_TEMPLATE');
    return this.http.post<TREPONSE_TNA_TEMPLATE_UPDATE_SUCCESS>(url, payload);
    //return of({ status: 'SUCCESS' });
  }

  copyTnaTemplate(templateId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('COPY_TNA_TEMPLATE').replace(':templateId', templateId);
    return this.http.post<void>(url, null);
  }

  getTnaDefaultSteps() {
    console.log('getTnaDefaultSteps');
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_DEFAULT_STEPS');
    return this.http.get<TRESPONSE_TNA_DEFAULT_STEPS>(url);
    //return of(tnaDefaultStepsMock);
  }

  createTnATemplate(payload: TREQUEST_CREATE_TNA_TEMPLATE) {
    console.log('createTnATemplate', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('CREATE_TNA_TEMPLATE');
    return this.http.post<TREPONSE_TNA_TEMPLATE_UPDATE_SUCCESS>(url, payload);
    //return of({ status: 'SUCCESS' });
  }

  getTnATemplateDetails(templateName: string) {
    console.log('getTnATemplateDetails');
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_TEMPLATE_DETAILS');
    return this.http.post<TRESPONSE_TNA_TEMPLATE_DETAILS>(url, { templateName });
  }

  addEditTnATemplateStep(payload: TREQUEST_ADD_EDIT_TNA_TEMPLATE_STEP) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_TNA_TEMPLATE_STEP');
    return this.http.post<TREPONSE_TNA_TEMPLATE_UPDATE_SUCCESS>(url, payload);
  }

  deleteTnaTemplateStep(payload: TREQUEST_DELETE_TNA_TEMPLATE_STEP) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_TNA_TEMPLATE_STEP');
    return this.http.post<TREPONSE_TNA_TEMPLATE_UPDATE_SUCCESS>(url, payload);
  }

  downloadTnaDetails(templateId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DOWNLOAD_TNA_DETAILS').replace(':templateId', templateId);
    return this.http.get(url, { responseType: 'blob' });
  }

  fetchOrderlist(payload: TREQUEST_ORDER_LIST, path: 'ORDER_LISTING_SCREEN' | 'ASSIGN TNA TO ORDERS SCREEN') {
    const url =
      path === 'ORDER_LISTING_SCREEN'
        ? this.plani8EnvironmentService.getUrlFromEnv('ORDER_LISTING')
        : this.plani8EnvironmentService.getUrlFromEnv('ORDER_LISTING_FROM_TNA');

    return this.http.post<TRESPONSE_ORDER_LIST>(url, payload);
    // return of(orderListResponse);
  }

  deleteOrders(payload: TREQUEST_DELETE_ORDERS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_ORDERS');
    return this.http.post(url, payload);
  }

  fetchOrderUploadDetails() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ORDER_DETAILS_MODEL');
    return this.http.get<TRESPONSE_ORDER_UPLOAD_DETAILS>(url);
  }

  // TnA ORDER TEMPLATE
  getTnAOrderTemplate(tnaOrderTemplateId: string) {
    console.log('getTnAOrderTemplate', tnaOrderTemplateId);
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('GET_TNA_ORDER_TEMPLATE')
      .replace(':tnaOrderTemplateId', tnaOrderTemplateId);
    return this.http.get<TRESPONSE_GET_TNA_ORDER_TEMPLATE>(url);
    // return of(orderTnATemplate);
  }

  updateStepByTemplateId(payload: TREQUEST_UPDATE_STEP_BY_TEMPLATE_ID) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_STEP_BY_TEMPLATE_ID');
    return this.http.post<void>(url, payload);
  }

  autoUpdateTnaTargetDates(payload: TREQUEST_AUTO_UPDATE_TARGET_DATES) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('AUTO_UPDATE_TARGET_DATES');
    return this.http.post<void>(url, payload);
  }

  updateTnAOrderTemplateStep(payload: TLiftedFormModel['payload']) {
    console.log('updateTnAOrderTemplateStep', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_TNA_ORDER_TEMPLATE_STEP');
    return this.http.post(url, payload);
  }

  deleteTnAOrderTemplateStep(payload: TLiftedFormModel['payload']) {
    console.log('deleteTnAOrderTemplateStep', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_TNA_ORDER_TEMPLATE_STEP');
    return this.http.post<TRESPONSE_TNA_ORDER_TEMPLATE>(url, payload);
  }

  downloadOrdetTnaTemplate(templateId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('DOWNLOAD_TNA_ORDER_TEMPLATE')
      .replace(':templateId', templateId);
    return this.http.get(url, { responseType: 'blob' });
  }

  // ASSIGN TNA TO ORDERS

  assignTnaToOrders(payload: TREQUEST_ASSIGN_TNA_TO_ORDERS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ASSIGN_TNA_TO_ORDERS');
    return this.http.post<TRESPONSE_ORDER_LIST>(url, payload);
    // return of(orderListResponse);
  }

  // TNA Board Api

  getTnaBoardListing(payload: TREQUEST_TNA_BOARD_LISTING) {
    console.log('getTnaBoardListing', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_BOARD_LISTING');
    //  return of(tnaBoardListing).pipe(delay(1000));
    return this.http.post<TRESPONSE_TNA_BOARD_LISTING>(url, payload);
  }

  getTnaBoardOrderInfo(orderId: string) {
    // console.log('getTnaBoardOrderInfo', orderId);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_ORDER_DETAILS').replace(':orderId', orderId);
    return this.http.get<TRESPONSE_TNA_BOARD_ORDER_DETAILS>(url);
  }

  getTnaBoardOrderProgress(orderId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_ORDER_PROGRESS').replace(':orderId', orderId);
    return this.http.get<TRESPONSE_TNA_BOARD_ORDER_PROGRESS>(url);
    // return of(tnaBoardOrderProgressResponse);
  }

  fetchOrderDetailsPlanningCard(
    payload: TREQUEST_ORDER_DETAILS_PLANNING_CARD,
    destination: 'LL_BOARD' | 'ORDER_DETAILS',
  ) {
    const url =
      destination === 'ORDER_DETAILS'
        ? this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_DETAILS_PLANNING_CARD')
        : this.plani8EnvironmentService.getUrlFromEnv('LL_PLANNING_DETAILS');
    return this.http.post<TRESPONSE_ORDER_DETAILS_PLANNING_CARD>(url, payload);
    // return of(planningCard);
  }

  getTnaBoardFilters(payload: TREQUEST_TNA_BOARD_FILTERS) {
    console.log('getTnaBoardFilters', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_BOARD_FILTERS');
    return this.http.post<TRESPONSE_TNA_BOARD_FILTERS>(url, payload);
    // return of({
    //   selectedFilters: [{displayName: "Order Id", key: "ORDER_ID", values: ["H&:ST:SU"]}],
    //   supportedFilters: [
    //     {
    //         "key": "ORDER_ID",
    //         "displayName": "Order Id",
    //         "searchable": true,
    //         "values": [ "H&:ST:SU", 'res1']
    //     },
    //     {
    //         "key": "STYLE",
    //         "displayName": "Style",
    //         "searchable": false,
    //         "values": ["STYLE1"]
    //     },
    //     {
    //         "key": "STATUS",
    //         "displayName": "Status",
    //         "searchable": true,
    //         "values": [
    //             "LATE_BUT_NOT_COMPLETED",
    //             "UPCOMING",
    //             "LATE_BUT_COMPLETED",
    //             "COMPLETED_ON_TIME"
    //         ]
    //     },
    //     {
    //       "key": "DURATION",
    //       "displayName": "DURATION",
    //       "searchable": false,
    //       "values": [
    //         {
    //         start: "2023-09-04",
    //         end: "2023-09-04",
    //         displayName: "TODAY"
    //         },
    //         {
    //         start: "2023-09-03",
    //         end: "2023-09-03",
    //         displayName: "YESTERDAY"
    //         },
    //         {
    //         start: "2023-09-04",
    //         end: "2023-09-10",
    //         displayName: "WEEKLY"
    //         },
    //         {
    //         start: "2023-09-04",
    //         end: "2023-10-03",
    //         displayName: "MONTHLY"
    //         },
    //         {
    //         start: "2023-09-04",
    //         end: "2023-09-05",
    //         displayName: "CUSTOM"
    //         },
    //         ]
    //   }
    // ]
    // })
  }

  getFiltersSearchResults(endPoint: keyof typeof Plani8EndPoints, payload: any) {
    console.log('getFiltersSearchResults', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv(endPoint);
    return this.http.post<TRESPONSE_TNA_BOARD_FILTERS_SEARCH_RES>(url, payload);
    //return of({searchResultItems: ['res1', 'res2']})
  }

  fetchOrderDetailsLearningCurveCard(payload: TREQUEST_ORDER_DETAILS_LEARNING_CURVE) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_DETAILS_LEARNING_CURVE_ORDER_EFFICIENCY');
    return this.http.post<TRESPONSE_ORDER_DETAILS_LEARNING_CURVE>(url, payload);
    // return of(learningCurveCard);
  }

  getAllLearningCurves() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_DETAILS_ALL_LEARNING_CURVES');
    return this.http.get<TRESPONSE_ORDER_DETAILS_ALL_LEARNING_CURVES>(url);
    // return of(allLearningCurves);
  }

  viewOrderDetailsLearningCurve(learningCurveId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('VIEW_ORDER_DETAILS_LEARNING_CURVE')
      .replace(':id', learningCurveId);
    // return of(viewLearningCurve);
    return this.http.get<TRESPONSE_ORDER_DETAILS_VIEW_LEARNING_CURVE>(url);
  }

  fetchOrderDetailsHeader(payload: TREQUEST_ORDER_DETAILS_HEADER) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_DETAILS_HEADER');
    return this.http.post<TRESPONSE_ORDER_DETAILS_HEADER>(url, payload);
    // return of(headerCard);
  }

  editOrderDetailsHeader(editPayload: TREQUEST_EDIT_ORDER_DETAILS_HEADER) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('EDIT_ORDER_DETAILS_HEADER');
    return this.http.post(url, editPayload);
  }

  markOrderNotRequired(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('MARK_ORDER_NOT_REQUIRED');
    return this.http.post(url, { id: otlId });
  }

  editDefaultCountOrderDetails(editPayload: TREQUEST_DEFAULT_COUNT_EDIT_ORDER_DETAILS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DEFAULT_COUNT_EDIT_ORDER_DETAILS_HEADER');
    return this.http.post<void>(url, editPayload);
  }

  editOrderDetailsLearningCurveOrderEfficiency(payload: TREQUEST_EDIT_LEARNING_CURVE_ORDER_EFFICIENCY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('EDIT_ORDER_DETAILS_LEARNING_CURVE_ORDER_EFFICIENCY');
    return this.http.post(url, payload);
  }

  //ASSIGN ORDER(S) TO FACTORIES

  assignSingleFactoryToOrder(payload: TREQUEST_ORDER_SINGLE_FACTORY_ALLOCATION) {
    console.log('assignSingleFactoryToOrder', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('ORDER_SINGLE_FACTORY_ALLOCATION');
    return this.http.post<TRESPONSE_ORDER_LIST>(url, payload);
    // return of(orderListResponse);
  }

  viewFactoryAllocationToOrder(payload: TREQUEST_ORDER_VIEW_FACTORY_ALLOCATION) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ORDER_VIEW_FACTORY_ALLOCATION');
    return this.http.post<TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS>(url, payload);
    // return of(orderListResponse);
  }

  getOrderToFactoriesSplitView(payload: TREQUEST_ORDER_ALLOCATION_CREATE_SPLIT_VIEW) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('VIEW_ORDER_FACTORY_SPLIT_FLOW');
    return this.http.post<TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS>(url, payload);
    //return of(getSplitView);
  }

  allocateOrderToMultipleFactories(payload: TREQUEST_ALLOCATE_ORDER_MULTIPLE_FACTORIES) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ORDER_ALLOCATION_MULTIPLE_FACTORIES');
    return this.http.post<void>(url, payload);
    // return of(orderListResponse);
  }

  //TNA Steps
  fetchTnaOrderStepList(payload: TREQUEST_GET_TNA_ORDER_STEP_LIST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_ORDER_STEP_LIST');
    return this.http.post<TRESPONSE_GET_TNA_ORDER_STEP_LIST>(url, payload);
  }

  getTnaOrderStep(tosId: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number]['tosId']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_ORDER_STEP').replace(':tosId', tosId);
    return this.http.get<TRESPONSE_GET_TNA_ORDER_STEP>(url);
  }

  updateTnaStep(payload: TREQUEST_UPDATE_TNA_STEP) {
    console.log('fetchTnaOrderStepList');
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_TNA_STEP');
    return this.http.post(url, payload);
  }

  bulkCompleteTnaOrderSteps(payload: TREQUEST_BULK_COMPLETE_TNA_ORDER_STEPS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('BULK_COMPLETE_TNA_ORDER_STEPS');
    return this.http.post<TRESPONSE_BULK_COMPLETE_TNA_ORDER_STEPS>(url, payload);
  }

  //TNA Approvals
  fetchTnaStepApprovalList(payload: TREQUEST_GET_TNA_STEP_APPROVAL_LIST) {
    console.log('here api');
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_STEP_APPROVAL_LIST');
    return this.http.post<TRESPONSE_GET_TNA_STEP_APPROVAL_LIST>(url, payload);
  }

  fetchTnaStepApprovalDetails(tosId: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number]['tosId']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_STEP_APPROVAL_DETAILS').replace(':tosId', tosId);
    return this.http.get<TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS>(url);
  }

  fetchEmployeedForTnaSTepApproval(approvalType: TApprovalType) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('GET_EMPLOYEES_FOR_STEP_APPROVAL')
      .replace(':approvalType', approvalType);
    return this.http.get<TRESPONSE_GET_TNA_STEP_APPROVAL_EMPLOYEES>(url);
  }

  requestTnaStepApproval(payload: TREQUEST_CREATE_TNA_STEP_APPROVAL_REQUEST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('REQUEST_TNA_STEP_APPROVAL');
    return this.http.post(url, payload);
  }

  fetchTnaStepApprovalPendingList(payload: TREQUEST_GET_TNA_STEP_APPROVAL_PENDING_LIST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_TNA_STEP_APPROVAL_PENDING_LIST');
    return this.http.post<TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST>(url, payload);
  }

  fetchTnaStepApprovalPendingDetails(
    approvalId: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST['stepApprovalPendingItems'][number]['tnaStepApprovalId'],
  ) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('GET_TNA_STEP_APPROVAL_PENDING_DETAILS')
      .replace(':approvalId', approvalId);
    return this.http.get<TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS>(url);
  }

  updateTnaStepApproval(payload: TREQUEST_UPDATE_TNA_STEP_APPROVAL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_TNA_STEP_APPROVAL');
    return this.http.post(url, payload);
  }

  // LL Board Configs

  getLineShiftInfo(subjectId: string, factoryId: string, shiftId?: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_LL_SHIFT_INFO').replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_LL_SHIFT>(url, {
      subject_id: subjectId,
      ...(shiftId ? { shift_id: shiftId } : {}),
    });
    //return of(shiftSetupMock['res'] as TRESPONSE_LL_SHIFT);
  }

  addEditLineWorkingHours(factoryId: string, payload: TREQUEST_ADD_EDIT_LINE_WORKING_HOURS) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('LL_ADD_EDIT_WORKING_HOURS')
      .replace(':factoryId', factoryId);
    return this.http.post(url, payload);
    // return of({
    //   status: 'SUCCESS',
    //   message: '',
    // });
  }

  resetLineWorkingHours(factoryId: string, payload: TREQUEST_RESET_LINE_SHIFT_COUNT) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_RESET_WORKING_HOURS').replace(':factoryId', factoryId);
    return this.http.post(url, payload);
    //return of(shiftSetupMock['res'] as TRESPONSE_LL_SHIFT);
  }

  getStripLevelEfficiency(stripId: string, payload: TREQUEST_VIEW_STRIP_LEVEL_EFFICIENCY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_GET_STRIP_EFFICIENCY').replace(':stripId', stripId);
    // return of(viewStripLevelEfficiency);
    return this.http.post<TRESPONSE_VIEW_STRIP_LEVEL_EFFICIENCY>(url, payload);
  }

  editStripLevelEfficiency(stripId: string, payload: TREQUEST_EDIT_STRIP_LEVEL_EFFICIENCY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_EDIT_STRIP_EFFICIENCY').replace(':stripId', stripId);
    return this.http.post(url, payload);
  }

  getOTLEfficiency(orderTnaId: string, payload: TREQUEST_VIEW_OTL_EFFICIENCY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_GET_OTL_EFFICIENCY').replace(':orderTnaId', orderTnaId);
    // return of(viewOTLEfficiency);
    return this.http.post<TRESPONSE_VIEW_OTL_EFFICIENCY>(url, payload);
  }

  editOTLEfficiency(orderTnaId: string, payload: TREQUEST_EDIT_OTL_EFFICIENCY) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('LL_EDIT_OTL_EFFICIENCY')
      .replace(':orderTnaId', orderTnaId);
    return this.http.post(url, payload);
  }

  resetStripLevelEfficiency(stripId: string, payload: TREQUEST_RESET_STRIP_LEVEL_EFFICIENCY) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('LL_RESET_STRIP_EFFICIENCY')
      .replace(':stripId', stripId)
      .replace(':efficiencyConfigType', payload.type);
    // .replace(':shiftId', payload.shift_id ?? '');
    return this.http.post(url, payload);
  }

  resetOTLEfficiency(orderTnaId: string, payload: TREQUEST_RESET_OTL_EFFICIENCY) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('LL_RESET_OTL_EFFICIENCY')
      .replace(':orderTnaId', orderTnaId)
      .replace(':efficiencyConfigType', payload.type);
    // .replace(':shiftId', payload.shift_id ?? '');
    return this.http.post(url, payload);
  }

  getLLBoardList(payload: TREQUEST_LlBoardListing) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_BOARD_LISTING');
    return this.http.post<TRESPONSE_LLBoardListing>(url, payload);
  }

  getOPLDetails(oplId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_OPL_DETAILS').replace(':stripId', oplId);
    // return of(MOCK_LLBoardListing);
    return this.http.get<TRESPONSE_OPLDetailsDTO>(url);
  }

  loadOrder(payload: TREQUEST_LL_LOAD_ORDER) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_LOAD_ORDER');
    return this.http.post<TRESPONSE_GENERAL_HTTP | TRESPONSE_STRIPS_OVERLAPPING>(url, payload);
  }

  fetchLLOrderListing(payload: TREQUEST_ORDER_LIST, bucketInfo: TOrderListingBucketInfo) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_ORDER_LISTING').replace(':bucketInfo', bucketInfo);
    // return of(orderListResponse);
    return this.http.post<TRESPONSE_ORDER_LIST>(url, payload);
  }

  fetchLLOPLListing(payload: TREQUEST_ORDER_LIST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_OPL_LISTING');
    return this.http.post<TRESPONSE_OPL_LIST>(url, payload);
  }

  fetchPlannedOrderProgess(payload: TREQUEST_PLANNED_ORDER_PROGRESS, stripId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_PLANNED_ORDER_PROGRESS').replace(':stripId', stripId);
    // return of(plannedOrderProgress);
    return this.http.post<TRESPONSE_PLANNED_ORDER_PROGRESS>(url, payload);
  }

  getLLBoardFilters(payload: TREQUEST_TNA_BOARD_FILTERS) {
    console.log('getLLBoardFilters', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_FILTERS_API');
    return this.http.post<TRESPONSE_TNA_BOARD_FILTERS>(url, payload);
    // return of({
    //   selectedFilters: [{displayName: "Order Id", key: "ORDER_ID", values: ["H&:ST:SU"]}],
    //   supportedFilters: [
    //     {
    //         "key": "ORDER_ID",
    //         "displayName": "Order Id",
    //         "searchable": true,
    //         "values": [ "H&:ST:SU", 'res1']
    //     },
    //     {
    //         "key": "STYLE",
    //         "displayName": "Style",
    //         "searchable": false,
    //         "values": ["STYLE1"]
    //     },
    //     {
    //         "key": "STATUS",
    //         "displayName": "Status",
    //         "searchable": true,
    //         "values": [
    //             "LATE_BUT_NOT_COMPLETED",
    //             "UPCOMING",
    //             "LATE_BUT_COMPLETED",
    //             "COMPLETED_ON_TIME"
    //         ]
    //     }
    // ]
    // })
  }

  getLLPollStatus() {
    console.log('getLLPollStatus');
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_POLL_STATUS');
    return this.http.get<TRESPONSE_LL_POLL_STATUS>(url);
    // this.llFetchCounter++;
    // if (this.llFetchCounter === 5) return of({ pollFurther: false, pollIntervalInSeconds: 2 });

    // return of({ pollFurther: true, pollIntervalInSeconds: 2 });
  }

  syncLLBoard() {
    console.log('syncLLBoard');

    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_SYNC_BOARD');
    return this.http.get<TRESPONSE_LL_POLL_STATUS>(url);
    //return of({});
  }

  jitStrip(stripId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_JIT_STRIP');
    return this.http.post<string>(url, { stripId });
  }

  splitStrip(payload: TREQUEST_LL_SPLIT_STRIP_ACTION) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_SPLIT_STRIP');
    return this.http.post<TRESPONSE_GENERAL_HTTP | TRESPONSE_STRIPS_OVERLAPPING>(url, payload);
  }

  linkStrip(payload: TREQUEST_LL_LINK_STRIP) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_LINK_STRIP');
    return this.http.post<void>(url, payload);
  }

  mergeStrips(payload: TREQUEST_LL_MERGE_STRIPS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_MERGE_STRIPS');
    return this.http.post<void>(url, payload);
  }
  unlinkStrip(stripId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_UNLINK_STRIP').replace(':stripId', stripId);
    return this.http.post<void>(url, null);
  }

  continueLinkStrip(payload: TREQUEST_LL_CONTINUE_LINK_STRIP) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_LINK_CONTINUE_STRIP');
    return this.http.post<void>(url, payload);
  }

  getSplitQtyByDate(payload: TREQUEST_LL_GET_QTY_BY_DATE) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_GET_QTY_BY_DATE');
    return this.http.post<TRESPONSE_LL_GET_QTY_BY_DATE>(url, payload);
  }

  getSplitQtyByDely(payload: TREQUEST_LL_GET_QTY_BY_DELAY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_GET_QTY_BY_DELAY');
    return this.http.post<TRESPONSE_LL_GET_QTY_BY_DELAY>(url, payload);
  }

  pullForwardStrip(payload: TREQUEST_LL_PULL_FORWARD) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('PULL_FORWARD_STRIP');
    return this.http.post<void>(url, payload);
  }

  llSearchStrips(payload: TREQUEST_LL_SEARCH_STRIPS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_SEARCH');
    return this.http.post<TRESPONSE_LL_SEARCH_STRIPS>(url, payload);
  }

  recalibrateLLBoard(mode: TLL_RECALIBRATE_TYPES) {
    console.log('recalibrateLLBoard', mode);
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_RECALIBRATE_API');
    return this.http.post(url, { recalibrationMode: mode });
    //return of({});
  }

  getLLTaskManager() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_GET_TASK_MANAGER');
    return this.http.get<TRESPONSE_LL_TASK_MANAGER>(url);
    // return of({
    //   details: [
    //     {
    //       taskName: 'recalibrate',
    //       actions: ['recalibrate'],
    //       eventStartEpoch: 123,
    //       eventCompleteEpoch: 456,
    //       eventStatus: 'Complete',
    //     },
    //     {
    //       taskName: 'Periodic Recalibration',
    //       actions: [
    //         'Operator count change',
    //         'Working hours change',
    //         'SMV change',
    //         'Learning curve change',
    //         'Product type/line change',
    //       ],
    //       eventStartEpoch: 123,
    //       eventCompleteEpoch: 456,
    //       eventStatus: 'In progress',
    //     },
    //   ],
    // });
  }

  //HL board

  getHLBoardList(payload: TREQUEST_HL_BOARD_LISTING) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_BOARD_LISTING');
    return this.http.post<TRESPONSE_HL_BOARD_LISTING>(url, payload);
    //return of(hlWeeklyClusterView2);
  }

  getHLBoardFilters(payload: TREQUEST_TNA_BOARD_FILTERS) {
    console.log('getLLBoardFilters', payload);
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_BOARD_FILTERS_API');
    return this.http.post<TRESPONSE_TNA_BOARD_FILTERS>(url, payload);
  }

  syncHLBoard() {
    console.log('syncHLBoard');
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_SYNC_BOARD');
    return this.http.get<TRESPONSE_HL_POLL_STATUS>(url);
  }

  getHLPollStatus() {
    console.log('getHLPollStatus');
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_BOARD_POLL_STATUS');
    return this.http.get<TRESPONSE_HL_POLL_STATUS>(url);
  }

  getHLBoardSectionWiseListing(payload: TREQUEST_HL_BOARD_SECTION_WISE_LISTING) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_BOARD_SECTION_WISE_LISTING');
    return this.http.post<TRESPONSE_HL_BOARD_SECTION_WISE_LISTING>(url, payload);
  }

  getOTLCapacitiesInfo(payload: TREQUEST_OTL_CAPACITIES_INFO) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_OPL_CAPACITIES_INFO');
    return this.http.post<TRESPONSE_OTL_CAPACITIES_INFO>(url, payload);
    //return of(otlCapacitiesMock);
  }

  getWeeklyOPLCapacitiesInfo(payload: TREQUEST_OPL_CAPACITIES_INFO) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_OTL_CAPACITIES_INFO');
    return this.http.post<TRESPONSE_WEEKLY_OPL_CAPACITIES>(url, payload);
    //return of(weeklyOPlCapacityMock);
  }

  getDailyOPLCapacitiesInfo(payload: TREQUEST_OPL_CAPACITIES_INFO) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_OTL_CAPACITIES_INFO');
    return this.http.post<TRESPONSE_DAILY_OPL_CAPACITIES>(url, payload);
    //return of(dailyOPLCapacities);
  }

  getDailyOPLCapacitiesFilter(payload: TREQUEST_DAILY_OPL_CAPACITIES_FILTERS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('HL_OTL_FILTERS_API');
    return this.http.post<TRESPONSE_TNA_BOARD_FILTERS>(url, payload);
  }

  //order details

  startOrderDetailsSync(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('START_ORDER_DETAILS_SYNC').replace(':otlId', otlId);
    return this.http.get<TRESPONSE_START_ORDER_DETAILS_SYNC>(url);
  }

  getOrderDetailsPollStatus(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_DETAILS_POLL_STATUS').replace(':otlId', otlId);
    return this.http.get<TRESPONSE_ORDER_DETAILS_POLL_STATUS>(url);
  }

  //Order Details PO Card

  getOrderPoCardDetails(payload: TLiftedFormModel['payload']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PO_CARD_DETAILS');
    return this.http.post<TRESPONSE_PO_DETAILS_CARD>(url, payload);
    // return of(orderPoCardDetails);
  }

  updatePoCardOrder(payload: TLiftedFormModel['payload']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_PO_CARD_ORDER');
    return this.http.post(url, payload);
  }

  deletePoCardOrders(payload: TLiftedFormModel['payload']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_PO_CARD_ORDER');
    return this.http.post(url, payload);
  }

  fetchFactoryNames() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_NAMES');
    return this.http.get<{ factoryName: string; factoryId: string }[]>(url);
  }

  fetchPoColorSizQtyDetails(payload: TLiftedFormModel['payload']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PO_COLOR_SIZE_QTY_DATA');
    return this.http.post<TRESPONSE_PO_DETAILS_COLOR_SIZE>(url, payload);
    // return of(editColorSizeResponse);
  }

  updatePoColorQtyByRatio(payload: TLiftedFormModel['payload']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_PO_COLOR_QTY_BY_RATIO');
    return this.http.post(url, payload);
  }

  updatePoColorSizeQtyManually(payload: TLiftedFormModel['payload']) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('UPDATE_PO_COLOR_SIZE_QTY_MANUALLY');
    return this.http.post(url, payload);
  }

  // Order Allocation Card
  fetchAllocationCardDetails(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ALLOCATION_CARD_DETAILS').replace(':otlId', otlId);
    return this.http.get<TRESPONSE_ORDER_ALLOCATION_CARD_DATA>(url);
    // return of(orderAllocationCardDetails);
  }

  fetchOrderTimelineCardDetails(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_TIMELINE_CARD_DETAILS').replace(':otlId', otlId);
    return this.http.get<TRESPONSE_ORDER_TIMELINE_CARD_DATA>(url);
  }

  fetchLinewisePlannedQtyCardDetails(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_LINEWISE_PLANNED_QTY_CARD_DETAILS');
    return this.http.post<TRESPONSE_LINEWISE_PLANNED_QTY_CARD_DATA>(url, { id: otlId });
  }

  fetchOperationBreakdownDetails(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_OPERATION_BREAKDOWN_DETAILS').replace(':otlId', otlId);
    return this.http.get<TRESPONSE_OPERATION_BREAKDOWN_DETAILS_DATA>(url);
  }

  fetchViewOrderFactoryAllocation(requestPayload: TREQUEST_ORDER_VIEW_FACTORY_ALLOCATION) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('VIEW_ORDER_ALLOCATION_EDIT_FLOW')
      .replace(':otlId', requestPayload.id);
    return this.http.post<TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS>(url, null);
  }

  deleteAllocation(payload: TREQUEST_ORDER_DETAILS_DELETE_ALLOCATION) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_ALLOCATION');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, payload);
  }

  deleteAllocationByFactory(payload: TREQUEST_ORDER_DETAILS_DELETE_ALLOCATION_BY_FACTORY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_ALLOCATION_BY_FACTORY');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, payload);
  }

  //LL Board Learning Curve Config
  getLLLearningCurveInfo(stripId: string, shiftId?: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_LL_LEARNING_CURVE_INFO').replace(':stripId', stripId);
    // .replace(':shiftId', shiftId ?? '');
    return this.http.post<TRESPONSE_LL_LEARNING_CURVE_DETAILS>(url, { shift_id: shiftId });
    // return of(stripLearningCurveMock);
  }

  incrementLLLearningDayCount(stripId: string, payload: TREQUEST_LL_ADD_LEARNING_CURVE_DAY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_INCREMENT_LC_DAY_COUNT').replace(':stripId', stripId);
    return this.http.post(url, payload);
    // return of({
    //   status: 'SUCCESS',
    //   message: '',
    // });
  }

  addEditLLLearningCurves(stripId: string, payload: TREQUEST_ADD_UPDATE_LL_LEARNING_CURVE) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_ADD_EDIT_LC_EFFICIENCY').replace(':stripId', stripId);
    return this.http.post(url, payload);
  }

  deleteLLLearningCurveStrip(stripId: string, shiftId?: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_DELETE_LC_STRIP');
    return this.http.post(url, { strip_id: stripId, ...(shiftId ? { shift_id: shiftId } : {}) });
  }

  getLLLearningCurveByFactoryOTL(factoryId: string, otlId: string, shiftId?: string) {
    const payload = {
      factory_id: factoryId,
      otl_id: otlId,
      ...(shiftId ? { shift_id: shiftId } : {}),
    };
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_LL_LEARNING_CURVE_BY_FACTORY_OTL');
    return this.http.post<TRESPONSE_LL_LEARNING_CURVE_BY_FACTORY_OTL>(url, payload);
  }

  addEditLLLearningCurveByFactoryOTL(payload: TREQUEST_ADD_UPDATE_LL_LC_BY_FACTORY_OTL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_ADD_EDIT_LC_BY_FACTORY_OTL');
    return this.http.post(url, payload);
  }

  resetLLLearningCurveByFactoryOTL(payload: TREQUEST_RESET_LL_LC_BY_FACTORY_OTL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_RESET_LC_BY_FACTORY_OTL');
    return this.http.post<void>(url, payload);
  }

  resetLearningCurveFromOrderDetails(payload: TREQUEST_RESET_LL_LC_BY_FACTORY_OTL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('RESET_LC_FROM_ORDER_DETAILS');
    return this.http.post<void>(url, payload);
  }

  //Line level Strip Listing
  fetchLineLevelStripListing(lineSubject: string, payload: TREQUEST_LINE_LEVEL_STRIP_LIST) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('FETCH_LINE_LEVEL_STRIPS')
      .replace(':lineSubject', lineSubject);
    return this.http.post<TRESPONSE_LINE_LEVEL_STRIP_LIST>(url, payload);
    // return of(lineLevelStripListMock);
  }

  //LL Board Actions continued
  shiftLLStrips(payload: TREQUEST_SHIFT_STRIPS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_SHIFT_ORDER');
    return this.http.post<TRESPONSE_GENERAL_HTTP | TRESPONSE_STRIPS_OVERLAPPING>(url, payload);
  }

  unloadMultipleStripRemoveOrders(payload: TREQUEST_UNLOAD_MULTIPLE_STRIPS_REMOVE_ORDERS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_UNLOAD_STRIP_REMOVE_MULTIPLE_ORDERS');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, payload);
  }

  unloadStripMovePartially(payload: TREQUEST_UNLOAD_STRIP_MOVE_PARTIALLY) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_UNLOAD_STRIP_MOVE_PARTIALLY');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, payload);
  }

  addEditNote(payload: TREQUEST_ADD_EDIT_NOTE) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_ADD_EDIT_NOTE');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, payload);
  }

  replanOutdatedStrip(stripId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_REPLAN_STRIP');
    return this.http.post<TRESPONSE_GENERAL_HTTP>(url, { stripId: stripId });
  }

  getStripPlannedNumbers(stripId: string, factoryId: string, shiftName?: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_STRIP_PLANNED_NUMBERS');
    return this.http.post<TRESPONSE_LINE_STRIP_PLANNED_NUMBERS>(url, { stripId, factoryId, shiftName });
  }

  getLoadOrderThresholds(payload: TREQUEST_LL_LOAD_ORDER_THRESHOLD) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LL_LOAD_ORDER_THRESHOLD');
    return this.http.post<TRESPONSE_LL_LOAD_ORDER_THRESHOLD>(url, payload);
  }

  getMerchandiserMetabaseUrl() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_MERCHANDISER_METABSE_URL');
    return this.http.get<string>(url);
  }

  getPlannerMetabaseUrl() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PLANNER_METABSE_URL');
    return this.http.get<string>(url);
  }

  getAnalyticsMetabaseUrl() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ANALYTICS_DASHBOARD_URL');
    return this.http.get<string>(url);
  }

  getMaterialInHouseDetails(stripId: string) {
    const url = this.plani8EnvironmentService
      .getUrlFromEnv('GET_MATERIAL_IN_HOUSE_DETAILS')
      .replace(':stripId', stripId);
    // return of(MOCK_MATERIAL_IN_HOUSE_RESPONSE).pipe(delay(1000));
    return this.http.get<TRESPONSE_MATERIAL_IN_HOUSE>(url);
  }

  getMaterialInHouseByOtl(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_MATERIAL_IN_HOUSE_BY_OTL').replace(':otlId', otlId);
    return this.http.get<TMaterialInHouseByOtlResponse>(url);
  }

  getFactoryAllocationListing(payload: TREQUEST_FACTORY_ALLOCATION_LISTING) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_ALLOCATION_LISTING');
    return this.http.post<TRESPONSE_FACTORY_ALLOCATION_LISTING>(url, payload);
  }

  getFactoryAllocationFilters() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_FACTORY_ALLOCATION_FILTERS');
    return this.http.get<TRESPONSE_FACTORY_ALLOCATION_FILTERS>(url);
  }

  factoryAllocationPartial(payload: TREQUEST_FACTORY_ALLOCATION_PARTIAL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('FACTORY_ALLOCATION_PARTIAL');
    return this.http.post<void>(url, payload);
  }

  //order checklist
  getOrderChecklistListing(payload: TREQUEST_ORDER_CHECKLIST_LISTING) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_CHECKLIST_LISTING');
    return this.http.post<TRESPONSE_ORDER_CHECKLIST_LISTING>(url, payload);
  }

  submitOrderChecklist(payload: TREQUEST_SUBMIT_ORDER_CHECKLIST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('SUBMIT_ORDER_CHECKLIST');
    return this.http.post<void>(url, payload);
  }

  bulkCompleteChecklist(payload: TREQUEST_BULK_COMPLETE_CHECKLIST) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('BULK_COMPLETE_CHECKLIST');
    return this.http.post<void>(url, payload);
  }

  getOrderChecklistByOTL(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_CHECKLIST_BY_OTL').replace(':otlId', otlId);
    return this.http.get<TOrderChecklistItem>(url);
  }

  fetchAllProcessess() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ALL_PROCESSES');
    return this.http.get<TRESPONSE_PROCESS_LISTING>(url);
  }

  createProcess(payload: TREQUEST_CREATE_PROCESS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('CREATE_PROCESS');
    return this.http.post<void>(url, payload);
  }

  deleteProcess(processId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_PROCESS');
    return this.http.post<void>(url, { processId });
  }

  addEditProcessMap(payload: TREQUEST_ADD_EDIT_PROCESS_MAP) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_PROCESS_MAP');
    return this.http.post<void>(url, payload);
  }

  addEditProcessMapToOtl(payload: TREQUEST_ADD_EDIT_PROCESS_MAP_TO_OTL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_PROCESS_MAP_TO_OTL');
    return this.http.post<void>(url, payload);
  }

  getProcessMapById(processMapId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PROCESS_MAP_BY_ID');
    return this.http.post<TRESPONSE_GET_PROCESS_MAP_BY_ID>(url, { processMapId });
  }

  fetchAllProcessMaps() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ALL_PROCESS_MAPS');
    return this.http.get<TRESPONSE_PROCESS_MAP_LISTING>(url);
  }

  setProcessMapAsDefault(processMapId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('SET_PROCESS_MAP_AS_DEFAULT');
    return this.http.post<void>(url, { processMapId });
  }

  deleteProcessMap(processMapId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('DELETE_PROCESS_MAP');
    return this.http.post<void>(url, { processMapId });
  }

  getProcessMapByOtlId(otlId: string) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PROCESS_MAP_BY_OTL_ID').replace(':orderId', otlId);
    return this.http.get<TRESPONSE_GET_PROCESS_MAP_BY_OTL_ID>(url);
  }

  // process boards
  getCapacityBoard(payload: TREQUEST_GET_CAPACITY_BOARD) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_CAPACITY_BOARD');
    return this.http.post<TRESPONSE_GET_CAPACITY_BOARD>(url, payload);
  }

  getOrderTimelineViewBoard(payload: TREQUEST_GET_ORDER_TIMELINE_VIEW) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_ORDER_TIMELINE_VIEW');
    return this.http.post<TRESPONSE_GET_ORDER_TIMELINE_VIEW>(url, payload);
  }

  syncCapacityBoard() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('SYNC_CAPACITY_BOARD');
    return this.http.get<void>(url);
  }

  getCapacityBoardStatus() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_CAPACITY_BOARD_STATUS');
    return this.http.get<TRESPONSE_GET_CAPACITY_BOARD_STATUS>(url);
  }

  getCapacityStripDetails(payload: TREQUEST_GET_CAPACITY_STRIP_DETAILS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_CAPACITY_STRIP_DETAILS');
    return this.http.post<TRESPONSE_GET_CAPACITY_STRIP_DETAILS>(url, payload);
  }

  closeOpl(payload: TREQUEST_CLOSE_OPL) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('CLOSE_OPL');
    return this.http.post<void>(url, payload);
  }

  closeOplByOplId(payload: TREQUEST_CLOSE_OPL_BY_OPL_ID) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('CLOSE_OPL_BY_OPL_ID');
    return this.http.post<void>(url, payload);
  }

  getOptimalPlanByOplId(payload: TREQUEST_GET_OPTIMAL_PLAN_BY_OPL_ID) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_OPTIMAL_PLAN_BY_OPL_ID');
    return this.http.post<TRESPONSE_GET_OPTIMAL_PLAN_BY_OPL_ID>(url, payload);
  }

  loadOplStrips(payload: TREQUEST_LOAD_OPL_STRIPS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('LOAD_OPL_STRIPS');
    return this.http.post<void>(url, payload);
  }

  getFactoryAssignListing() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PROCESS_FACTORY_ASSIGN_LISTING');
    return this.http.get<TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING>(url);
  }

  addEditProcessFactoryAssign(payload: TREQUEST_ADD_EDIT_PROCESS_FACTORY_ASSIGN) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('ADD_EDIT_PROCESS_FACTORY_ASSIGN');
    return this.http.post<void>(url, payload);
  }
  getPlanningBoard(payload: TREQUEST_GET_PLANNING_BOARD) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PLANNING_BOARD');
    return this.http.post<TRESPONSE_GET_PLANNING_BOARD>(url, payload);
  }
  getPlanningBoardFilters(payload: TREQUEST_TNA_BOARD_FILTERS) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('PLANNING_BOARD_FILTERS_API');
    return this.http.post<TRESPONSE_TNA_BOARD_FILTERS>(url, payload);
  }
  syncPlanningBoard() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('SYNC_PLANNING_BOARD');
    return this.http.get<TRESPONSE_LL_POLL_STATUS>(url);
  }
  planningBoardDaywiseOrderStatusByOtlid(payload: TREQUEST_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID) {
    const url = this.plani8EnvironmentService.getUrlFromEnv('PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID');
    return this.http.post<TRESPONSE_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID>(url, payload);
  }
  getPlanningBoardStatus() {
    const url = this.plani8EnvironmentService.getUrlFromEnv('GET_PLANNING_BOARD_STATUS');
    return this.http.get<TRESPONSE_GET_CAPACITY_BOARD_STATUS>(url);
  }
}
